/**
 * lib/hooks/use-current-user.ts
 *
 * The user whose role decides what the UI shows: the authenticated user,
 * else the demo UserSwitcher's active user (Decision 6).
 */
import { useAppStore, activeUserSelector } from '@/lib/store';
import { useAuthStore } from '@/lib/store/auth-slice';
import type { User } from '@/lib/types';

export function useCurrentUser(): User {
  const mockActiveUser = useAppStore(activeUserSelector);
  const authUser = useAuthStore((s) => s.user);
  return authUser ?? mockActiveUser;
}
